// Google Places Autocomplete para el campo "Dirección (Calle)" postal normal
// del cliente (NO el de "Ciudad del Incidente", que usa su propio
// CityStateAutocomplete y no se toca aquí). Mismo patrón ya probado en
// producción en el repo hermano commandix-labels
// (frontend/src/pages/AdminCentralLabelsPage.jsx). Se degrada en silencio a
// entrada 100% manual si REACT_APP_GOOGLE_PLACES_API_KEY no está puesta
// (frontend/.env, gitignored) o si el script de Google no carga por
// cualquier razón — nunca bloquea el formulario.

let _placesScriptPromise = null;

export function loadGooglePlaces() {
  const key = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
  if (!key) return Promise.resolve(false);
  if (window.google?.maps?.places) return Promise.resolve(true);
  if (_placesScriptPromise) return _placesScriptPromise;
  _placesScriptPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
    script.async = true;
    script.onload = () => resolve(!!window.google?.maps?.places);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
  return _placesScriptPromise;
}

export function parseGooglePlace(place) {
  const comps = place.address_components || [];
  const get = (type) => comps.find((c) => c.types.includes(type));
  const streetNumber = get("street_number")?.long_name || "";
  const route = get("route")?.long_name || "";
  const city = get("locality")?.long_name || get("postal_town")?.long_name || get("sublocality")?.long_name || "";
  const state = get("administrative_area_level_1")?.short_name || "";
  const zip = get("postal_code")?.long_name || "";
  const country = get("country")?.short_name || "US";
  return { street1: [streetNumber, route].filter(Boolean).join(" "), city, state, zip, country };
}
